<div class='row'>
    <div class='col text-left' *ngIf="datatable.paginacion.mostrarPaginacion && total > 0 && !calculatingTotal && datatable.paginacion.usarTotal !== false">
        <ngb-pagination
            [(page)]="page"
            [pageSize]="size"
            [maxSize]="isDesktop ? 5 : 1"
            [rotate]="!isDesktop"
            [collectionSize]="total"
            (pageChange)="paginaCambiada()"
            [ellipses]="isDesktop"
            >
        </ngb-pagination>
    </div>
    <div class='col text-left' *ngIf="datatable.paginacion.mostrarPaginacion && !calculatingTotal && datatable.paginacion.usarTotal === false">
        <ul class='pagination'>
            <li class='page-item' (click)="setPage(page - 1)" [ngClass]="page <= 1 ? 'disabled' : ''">
                <a class='page-link' href='javascript:void(0)' [ngClass]="page <= 1 ? 'disabled' : ''">Anterior</a>
            </li>
            <li class='page-item' (click)="setPage(page + 1)">
                <a class='page-link' href='javascript:void(0)'>Siguiente</a>
            </li>
        </ul>
    </div>
    <div class='col text-left' *ngIf="datatable.paginacion.mostrarPaginacion && calculatingTotal">
        Calculando...
    </div>
    <div class='col text-right'>
        <ng-content select='.right-content' class='right-content'></ng-content>
        <select *ngIf="datatable.paginacion.mostrarLimites" class="limit custom-select" (change)="sizeCambiado($event.target.value)" [(ngModel)]="size">
            <option *ngFor="let item of datatable.paginacion.limites; let i = index" [selected]="i == datatable.paginacion.limiteIndex">
                {{item}}
            </option>
        </select>
    </div>
</div>